import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../ranges/_Ranges.mjs';
import { Companion_instanceovl8he3jiijf as Companion_instance } from './AbstractList.mjs';
import {
  arrayCopytctsywo3h7gj as arrayCopy,
  arrayOfNulls3cqbl98qmfq5b as arrayOfNulls,
  terminateCollectionToArray12671uhv05xea as terminateCollectionToArray,
} from './collectionJs.mjs';
import { get_lastIndexx0qsydpfv3mu as get_lastIndex } from './_Arrays.mjs';
import { fill3hcjvebk42tyx as fill } from './_ArraysJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex_0 } from './CollectionsKt.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ensureCapacity($this, minCapacity) {
  if (minCapacity < 0)
    throw IllegalStateException().o4('Deque is too big.');
  if (minCapacity <= $this.tk_1.length)
    return Unit_instance;
  if ($this.tk_1 === Companion_getInstance().vk_1) {
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = coerceAtLeast(minCapacity, 10);
    tmp.tk_1 = Array(size);
    return Unit_instance;
  }
  var newCapacity = Companion_instance.va($this.tk_1.length, minCapacity);
  copyElements($this, newCapacity);
}
function copyElements($this, newCapacity) {
  // Inline function 'kotlin.arrayOfNulls' call
  var newElements = Array(newCapacity);
  var tmp0 = $this.tk_1;
  var tmp6 = $this.sk_1;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = $this.tk_1.length;
  arrayCopy(tmp0, newElements, 0, tmp6, endIndex);
  var tmp0_0 = $this.tk_1;
  var tmp4 = $this.tk_1.length - $this.sk_1 | 0;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex_0 = $this.sk_1;
  arrayCopy(tmp0_0, newElements, tmp4, 0, endIndex_0);
  $this.sk_1 = 0;
  $this.tk_1 = newElements;
}
function positiveMod($this, index) {
  return index >= $this.tk_1.length ? index - $this.tk_1.length | 0 : index;
}
function negativeMod($this, index) {
  return index < 0 ? index + $this.tk_1.length | 0 : index;
}
function incremented($this, index) {
  return index === get_lastIndex($this.tk_1) ? 0 : index + 1 | 0;
}
function decremented($this, index) {
  return index === 0 ? get_lastIndex($this.tk_1) : index - 1 | 0;
}
function copyCollectionElements($this, internalIndex, elements) {
  var iterator = elements.m1();
  var inductionVariable = internalIndex;
  var last = $this.tk_1.length;
  if (inductionVariable < last)
    $l$loop: do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!iterator.n1())
        break $l$loop;
      $this.tk_1[index] = iterator.o1();
    }
     while (inductionVariable < last);
  var inductionVariable_0 = 0;
  var last_0 = $this.sk_1;
  if (inductionVariable_0 < last_0)
    $l$loop_0: do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (!iterator.n1())
        break $l$loop_0;
      $this.tk_1[index_0] = iterator.o1();
    }
     while (inductionVariable_0 < last_0);
  $this.uk_1 = $this.uk_1 + elements.p1() | 0;
}
function removeRangeShiftPreceding($this, fromIndex, toIndex) {
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var index = fromIndex - 1 | 0;
  var copyFromIndex = positiveMod($this, $this.sk_1 + index | 0);
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var index_0 = toIndex - 1 | 0;
  var copyToIndex = positiveMod($this, $this.sk_1 + index_0 | 0);
  var copyCount = fromIndex;
  while (copyCount > 0) {
    var tmp0 = copyCount;
    var tmp2 = copyFromIndex + 1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var c = copyToIndex + 1 | 0;
    var segmentLength = Math.min(tmp0, tmp2, c);
    var tmp0_0 = $this.tk_1;
    var tmp2_0 = $this.tk_1;
    var tmp4 = (copyToIndex - segmentLength | 0) + 1 | 0;
    var tmp6 = (copyFromIndex - segmentLength | 0) + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = copyFromIndex + 1 | 0;
    arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
    copyFromIndex = negativeMod($this, copyFromIndex - segmentLength | 0);
    copyToIndex = negativeMod($this, copyToIndex - segmentLength | 0);
    copyCount = copyCount - segmentLength | 0;
  }
}
function removeRangeShiftSucceeding($this, fromIndex, toIndex) {
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var copyFromIndex = positiveMod($this, $this.sk_1 + toIndex | 0);
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var copyToIndex = positiveMod($this, $this.sk_1 + fromIndex | 0);
  var copyCount = $this.uk_1 - toIndex | 0;
  while (copyCount > 0) {
    var tmp0 = copyCount;
    var tmp2 = $this.tk_1.length - copyFromIndex | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var c = $this.tk_1.length - copyToIndex | 0;
    var segmentLength = Math.min(tmp0, tmp2, c);
    var tmp0_0 = $this.tk_1;
    var tmp2_0 = $this.tk_1;
    var tmp4 = copyToIndex;
    var tmp6 = copyFromIndex;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = copyFromIndex + segmentLength | 0;
    arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
    copyFromIndex = positiveMod($this, copyFromIndex + segmentLength | 0);
    copyToIndex = positiveMod($this, copyToIndex + segmentLength | 0);
    copyCount = copyCount - segmentLength | 0;
  }
}
function nullifyNonEmpty($this, internalFromIndex, internalToIndex) {
  if (internalFromIndex < internalToIndex) {
    fill($this.tk_1, null, internalFromIndex, internalToIndex);
  } else {
    fill($this.tk_1, null, internalFromIndex, $this.tk_1.length);
    fill($this.tk_1, null, 0, internalToIndex);
  }
}
function registerModification($this) {
  $this.p6_1 = $this.p6_1 + 1 | 0;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.vk_1 = [];
        this.wk_1 = 10;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function init_kotlin_collections_ArrayDeque(_this__u8e3s4) {
  Companion_getInstance();
  _this__u8e3s4.sk_1 = 0;
  _this__u8e3s4.uk_1 = 0;
}
var ArrayDequeClass;
function ArrayDeque() {
  if (ArrayDequeClass === VOID) {
    class $ extends AbstractMutableList() {
      p1() {
        return this.uk_1;
      }
      static xk() {
        Companion_getInstance();
        var $this = this.e7();
        init_kotlin_collections_ArrayDeque($this);
        $this.tk_1 = Companion_getInstance().vk_1;
        return $this;
      }
      i1() {
        return this.uk_1 === 0;
      }
      yk(element) {
        registerModification(this);
        ensureCapacity(this, this.uk_1 + 1 | 0);
        this.sk_1 = decremented(this, this.sk_1);
        this.tk_1[this.sk_1] = element;
        this.uk_1 = this.uk_1 + 1 | 0;
      }
      zk(element) {
        registerModification(this);
        ensureCapacity(this, this.uk_1 + 1 | 0);
        var tmp = this.tk_1;
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.uk_1;
        tmp[positiveMod(this, this.sk_1 + index | 0)] = element;
        this.uk_1 = this.uk_1 + 1 | 0;
      }
      al() {
        if (this.i1())
          throw NoSuchElementException().o('ArrayDeque is empty.');
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var internalIndex = this.sk_1;
        var tmp = this.tk_1[internalIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.tk_1[this.sk_1] = null;
        this.sk_1 = incremented(this, this.sk_1);
        this.uk_1 = this.uk_1 - 1 | 0;
        return element;
      }
      bl() {
        return this.i1() ? null : this.al();
      }
      cl() {
        if (this.i1())
          throw NoSuchElementException().o('ArrayDeque is empty.');
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = get_lastIndex_0(this);
        var internalLastIndex = positiveMod(this, this.sk_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.tk_1[internalLastIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.tk_1[internalLastIndex] = null;
        this.uk_1 = this.uk_1 - 1 | 0;
        return element;
      }
      v(element) {
        this.zk(element);
        return true;
      }
      y3(index, element) {
        Companion_instance.u6(index, this.uk_1);
        if (index === this.uk_1) {
          this.zk(element);
          return Unit_instance;
        } else if (index === 0) {
          this.yk(element);
          return Unit_instance;
        }
        registerModification(this);
        ensureCapacity(this, this.uk_1 + 1 | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.sk_1 + index | 0);
        if (index < (this.uk_1 + 1 | 0) >> 1) {
          var decrementedInternalIndex = decremented(this, internalIndex);
          var decrementedHead = decremented(this, this.sk_1);
          if (decrementedInternalIndex >= this.sk_1) {
            this.tk_1[decrementedHead] = this.tk_1[this.sk_1];
            var tmp0 = this.tk_1;
            var tmp2 = this.tk_1;
            var tmp4 = this.sk_1;
            var tmp6 = this.sk_1 + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = decrementedInternalIndex + 1 | 0;
            arrayCopy(tmp0, tmp2, tmp4, tmp6, endIndex);
          } else {
            var tmp0_0 = this.tk_1;
            var tmp2_0 = this.tk_1;
            var tmp4_0 = this.sk_1 - 1 | 0;
            var tmp6_0 = this.sk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_0 = this.tk_1.length;
            arrayCopy(tmp0_0, tmp2_0, tmp4_0, tmp6_0, endIndex_0);
            this.tk_1[this.tk_1.length - 1 | 0] = this.tk_1[0];
            var tmp0_1 = this.tk_1;
            var tmp2_1 = this.tk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = decrementedInternalIndex + 1 | 0;
            arrayCopy(tmp0_1, tmp2_1, 0, 1, endIndex_1);
          }
          this.tk_1[decrementedInternalIndex] = element;
          this.sk_1 = decrementedHead;
        } else {
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index_0 = this.uk_1;
          var tail = positiveMod(this, this.sk_1 + index_0 | 0);
          if (internalIndex < tail) {
            var tmp0_2 = this.tk_1;
            var tmp2_2 = this.tk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset = internalIndex + 1 | 0;
            arrayCopy(tmp0_2, tmp2_2, destinationOffset, internalIndex, tail);
          } else {
            var tmp0_3 = this.tk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destination = this.tk_1;
            arrayCopy(tmp0_3, destination, 1, 0, tail);
            this.tk_1[0] = this.tk_1[this.tk_1.length - 1 | 0];
            var tmp0_4 = this.tk_1;
            var tmp2_3 = this.tk_1;
            var tmp4_1 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_2 = this.tk_1.length - 1 | 0;
            arrayCopy(tmp0_4, tmp2_3, tmp4_1, internalIndex, endIndex_2);
          }
          this.tk_1[internalIndex] = element;
        }
        this.uk_1 = this.uk_1 + 1 | 0;
      }
      r1(elements) {
        if (elements.i1())
          return false;
        registerModification(this);
        ensureCapacity(this, this.uk_1 + elements.p1() | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.uk_1;
        var tmp$ret$0 = positiveMod(this, this.sk_1 + index | 0);
        copyCollectionElements(this, tmp$ret$0, elements);
        return true;
      }
      q1(index) {
        Companion_instance.f7(index, this.uk_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var internalIndex = positiveMod(this, this.sk_1 + index | 0);
        var tmp = this.tk_1[internalIndex];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      b2(index, element) {
        Companion_instance.f7(index, this.uk_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.sk_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.tk_1[internalIndex];
        var oldElement = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.tk_1[internalIndex] = element;
        return oldElement;
      }
      t1(element) {
        return !(this.s1(element) === -1);
      }
      s1(element) {
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.uk_1;
        var tail = positiveMod(this, this.sk_1 + index | 0);
        if (this.sk_1 < tail) {
          var inductionVariable = this.sk_1;
          if (inductionVariable < tail)
            do {
              var index_0 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (equals(element, this.tk_1[index_0]))
                return index_0 - this.sk_1 | 0;
            }
             while (inductionVariable < tail);
        } else if (this.sk_1 >= tail) {
          var inductionVariable_0 = this.sk_1;
          var last = this.tk_1.length;
          if (inductionVariable_0 < last)
            do {
              var index_1 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (equals(element, this.tk_1[index_1]))
                return index_1 - this.sk_1 | 0;
            }
             while (inductionVariable_0 < last);
          var inductionVariable_1 = 0;
          if (inductionVariable_1 < tail)
            do {
              var index_2 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              if (equals(element, this.tk_1[index_2]))
                return (index_2 + this.tk_1.length | 0) - this.sk_1 | 0;
            }
             while (inductionVariable_1 < tail);
        }
        return -1;
      }
      w3(element) {
        var index = this.s1(element);
        if (index === -1)
          return false;
        this.z3(index);
        return true;
      }
      z3(index) {
        Companion_instance.f7(index, this.uk_1);
        if (index === get_lastIndex_0(this)) {
          return this.cl();
        } else if (index === 0) {
          return this.al();
        }
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.sk_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.tk_1[internalIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        if (index < this.uk_1 >> 1) {
          if (internalIndex >= this.sk_1) {
            var tmp0 = this.tk_1;
            var tmp2 = this.tk_1;
            var tmp4 = this.sk_1 + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex = this.sk_1;
            arrayCopy(tmp0, tmp2, tmp4, startIndex, internalIndex);
          } else {
            var tmp0_0 = this.tk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destination = this.tk_1;
            arrayCopy(tmp0_0, destination, 1, 0, internalIndex);
            this.tk_1[0] = this.tk_1[this.tk_1.length - 1 | 0];
            var tmp0_1 = this.tk_1;
            var tmp2_0 = this.tk_1;
            var tmp4_0 = this.sk_1 + 1 | 0;
            var tmp6 = this.sk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.tk_1.length - 1 | 0;
            arrayCopy(tmp0_1, tmp2_0, tmp4_0, tmp6, endIndex);
          }
          this.tk_1[this.sk_1] = null;
          this.sk_1 = incremented(this, this.sk_1);
        } else {
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index_0 = get_lastIndex_0(this);
          var internalLastIndex = positiveMod(this, this.sk_1 + index_0 | 0);
          if (internalIndex <= internalLastIndex) {
            var tmp0_2 = this.tk_1;
            var tmp2_1 = this.tk_1;
            var tmp6_0 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_0 = internalLastIndex + 1 | 0;
            arrayCopy(tmp0_2, tmp2_1, internalIndex, tmp6_0, endIndex_0);
          } else {
            var tmp0_3 = this.tk_1;
            var tmp2_2 = this.tk_1;
            var tmp6_1 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = this.tk_1.length;
            arrayCopy(tmp0_3, tmp2_2, internalIndex, tmp6_1, endIndex_1);
            this.tk_1[this.tk_1.length - 1 | 0] = this.tk_1[0];
            var tmp0_4 = this.tk_1;
            var tmp2_3 = this.tk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_2 = internalLastIndex + 1 | 0;
            arrayCopy(tmp0_4, tmp2_3, 0, 1, endIndex_2);
          }
          this.tk_1[internalLastIndex] = null;
        }
        this.uk_1 = this.uk_1 - 1 | 0;
        return element;
      }
      w2(elements) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.ArrayDeque.filterInPlace' call
          var tmp;
          if (this.i1()) {
            tmp = true;
          } else {
            // Inline function 'kotlin.collections.isEmpty' call
            tmp = this.tk_1.length === 0;
          }
          if (tmp) {
            tmp$ret$1 = false;
            break $l$block;
          }
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.uk_1;
          var tail = positiveMod(this, this.sk_1 + index | 0);
          var newTail = this.sk_1;
          var modified = false;
          if (this.sk_1 < tail) {
            var inductionVariable = this.sk_1;
            if (inductionVariable < tail)
              do {
                var index_0 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = this.tk_1[index_0];
                var it = (element == null ? true : !(element == null)) ? element : THROW_CCE();
                if (!elements.t1(it)) {
                  var tmp_0 = this.tk_1;
                  var _unary__edvuaz = newTail;
                  newTail = _unary__edvuaz + 1 | 0;
                  tmp_0[_unary__edvuaz] = element;
                } else {
                  modified = true;
                }
              }
               while (inductionVariable < tail);
            fill(this.tk_1, null, newTail, tail);
          } else {
            var inductionVariable_0 = this.sk_1;
            var last = this.tk_1.length;
            if (inductionVariable_0 < last)
              do {
                var index_1 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var element_0 = this.tk_1[index_1];
                this.tk_1[index_1] = null;
                var it_0 = (element_0 == null ? true : !(element_0 == null)) ? element_0 : THROW_CCE();
                if (!elements.t1(it_0)) {
                  var tmp_1 = this.tk_1;
                  var _unary__edvuaz_0 = newTail;
                  newTail = _unary__edvuaz_0 + 1 | 0;
                  tmp_1[_unary__edvuaz_0] = element_0;
                } else {
                  modified = true;
                }
              }
               while (inductionVariable_0 < last);
            newTail = positiveMod(this, newTail);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < tail)
              do {
                var index_2 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var element_1 = this.tk_1[index_2];
                this.tk_1[index_2] = null;
                var it_1 = (element_1 == null ? true : !(element_1 == null)) ? element_1 : THROW_CCE();
                if (!elements.t1(it_1)) {
                  this.tk_1[newTail] = element_1;
                  newTail = incremented(this, newTail);
                } else {
                  modified = true;
                }
              }
               while (inductionVariable_1 < tail);
          }
          if (modified) {
            registerModification(this);
            this.uk_1 = negativeMod(this, newTail - this.sk_1 | 0);
          }
          tmp$ret$1 = modified;
        }
        return tmp$ret$1;
      }
      x3(elements) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.ArrayDeque.filterInPlace' call
          var tmp;
          if (this.i1()) {
            tmp = true;
          } else {
            // Inline function 'kotlin.collections.isEmpty' call
            tmp = this.tk_1.length === 0;
          }
          if (tmp) {
            tmp$ret$1 = false;
            break $l$block;
          }
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.uk_1;
          var tail = positiveMod(this, this.sk_1 + index | 0);
          var newTail = this.sk_1;
          var modified = false;
          if (this.sk_1 < tail) {
            var inductionVariable = this.sk_1;
            if (inductionVariable < tail)
              do {
                var index_0 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = this.tk_1[index_0];
                var it = (element == null ? true : !(element == null)) ? element : THROW_CCE();
                if (elements.t1(it)) {
                  var tmp_0 = this.tk_1;
                  var _unary__edvuaz = newTail;
                  newTail = _unary__edvuaz + 1 | 0;
                  tmp_0[_unary__edvuaz] = element;
                } else {
                  modified = true;
                }
              }
               while (inductionVariable < tail);
            fill(this.tk_1, null, newTail, tail);
          } else {
            var inductionVariable_0 = this.sk_1;
            var last = this.tk_1.length;
            if (inductionVariable_0 < last)
              do {
                var index_1 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var element_0 = this.tk_1[index_1];
                this.tk_1[index_1] = null;
                var it_0 = (element_0 == null ? true : !(element_0 == null)) ? element_0 : THROW_CCE();
                if (elements.t1(it_0)) {
                  var tmp_1 = this.tk_1;
                  var _unary__edvuaz_0 = newTail;
                  newTail = _unary__edvuaz_0 + 1 | 0;
                  tmp_1[_unary__edvuaz_0] = element_0;
                } else {
                  modified = true;
                }
              }
               while (inductionVariable_0 < last);
            newTail = positiveMod(this, newTail);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < tail)
              do {
                var index_2 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var element_1 = this.tk_1[index_2];
                this.tk_1[index_2] = null;
                var it_1 = (element_1 == null ? true : !(element_1 == null)) ? element_1 : THROW_CCE();
                if (elements.t1(it_1)) {
                  this.tk_1[newTail] = element_1;
                  newTail = incremented(this, newTail);
                } else {
                  modified = true;
                }
              }
               while (inductionVariable_1 < tail);
          }
          if (modified) {
            registerModification(this);
            this.uk_1 = negativeMod(this, newTail - this.sk_1 | 0);
          }
          tmp$ret$1 = modified;
        }
        return tmp$ret$1;
      }
      v3() {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.i1()) {
          registerModification(this);
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.uk_1;
          var tail = positiveMod(this, this.sk_1 + index | 0);
          nullifyNonEmpty(this, this.sk_1, tail);
        }
        this.sk_1 = 0;
        this.uk_1 = 0;
      }
      dl(array) {
        var tmp = array.length >= this.uk_1 ? array : arrayOfNulls(array, this.uk_1);
        var dest = isArray(tmp) ? tmp : THROW_CCE();
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.uk_1;
        var tail = positiveMod(this, this.sk_1 + index | 0);
        if (this.sk_1 < tail) {
          var tmp0 = this.tk_1;
          // Inline function 'kotlin.collections.copyInto' call
          var startIndex = this.sk_1;
          arrayCopy(tmp0, dest, 0, startIndex, tail);
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.i1()) {
            var tmp0_0 = this.tk_1;
            var tmp6 = this.sk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.tk_1.length;
            arrayCopy(tmp0_0, dest, 0, tmp6, endIndex);
            var tmp0_1 = this.tk_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset = this.tk_1.length - this.sk_1 | 0;
            arrayCopy(tmp0_1, dest, destinationOffset, 0, tail);
          }
        }
        var tmp_0 = terminateCollectionToArray(this.uk_1, dest);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      e8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.uk_1;
        var tmp$ret$0 = Array(size);
        return this.dl(tmp$ret$0);
      }
      toArray() {
        return this.e8();
      }
      g7(fromIndex, toIndex) {
        Companion_instance.r5(fromIndex, toIndex, this.uk_1);
        var length = toIndex - fromIndex | 0;
        if (length === 0)
          return Unit_instance;
        else if (length === this.uk_1) {
          this.v3();
          return Unit_instance;
        } else if (length === 1) {
          this.z3(fromIndex);
          return Unit_instance;
        }
        registerModification(this);
        if (fromIndex < (this.uk_1 - toIndex | 0)) {
          removeRangeShiftPreceding(this, fromIndex, toIndex);
          var newHead = positiveMod(this, this.sk_1 + length | 0);
          nullifyNonEmpty(this, this.sk_1, newHead);
          this.sk_1 = newHead;
        } else {
          removeRangeShiftSucceeding(this, fromIndex, toIndex);
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.uk_1;
          var tail = positiveMod(this, this.sk_1 + index | 0);
          nullifyNonEmpty(this, negativeMod(this, tail - length | 0), tail);
        }
        this.uk_1 = this.uk_1 - length | 0;
      }
    }
    initMetadataForClass($, 'ArrayDeque', $.xk);
    ArrayDequeClass = $;
  }
  return ArrayDequeClass;
}
//region block: exports
export {
  ArrayDeque as ArrayDeque2dzc9uld4xi7n,
};
//endregion

//# sourceMappingURL=ArrayDeque.mjs.map
